module.exports = __webpack_public_path__ + "static/media/icomoon.e9dd3a32.ttf";